import * as XLSX from 'xlsx';
import XLSXStyle from 'xlsx-js-style';
import { SCRAP_CASING_TYRE_EXPORT_COLUMN_KEYS, isScrapTyreStatus } from './scrapConstants';

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};

export const EXCEL_DATE_FORMAT = 'dd-mm-yyyy';

/** SheetJS's built-in default for a Date cell (XLSX.SSF table entry 14). */
const SHEETJS_DEFAULT_DATE_FORMAT = 'm/d/yy';

/**
 * A Date handed to json_to_sheet without `dateNF` keeps SheetJS's default
 * 'm/d/yy', so 19 Aug 2026 opens in Excel as 8/19/26. Rewrites any such cell
 * to Indian dd-mm-yyyy and drops the time-of-day fraction so the serial is a
 * whole day (otherwise date filters and sorts treat identical days as unequal).
 */
const normalizeDateCells = (ws) => {
  if (!ws['!ref']) return;
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let r = range.s.r; r <= range.e.r; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (!cell || cell.t !== 'n') continue;
      if (cell.z === SHEETJS_DEFAULT_DATE_FORMAT) cell.z = EXCEL_DATE_FORMAT;
      if (cell.z === EXCEL_DATE_FORMAT) cell.v = Math.round(cell.v);
    }
  }
};

export const exportExcel = (data, fileName, totalRow = null, mergeCols = 2) => {
  console.log('excelData--',data);
  
  // data?.forEach((item) => {
  //   delete item._id;
    // if (item?.["last Inspectino Date"] || item?.["Last Inspection Date"] || item?.["Enrollment Date"] || item?.["Raising Date"] || item?.["Last Rotation Date"] || item?.["Last Alignment Date"] || item?.["Removal Date"]) {
    //   if(item?.["last Inspectino Date"]) {
    //   item["last Inspectino Date"] = item?.["last Inspectino Date"].replace(/-/g, "/");
    //   }
    //   if(item?.["Last Inspection Date"]){
    //     item["Last Inspection Date"] = item?.["Last Inspection Date"].replace(/-/g, "/");
    //   }

    //   if(item?.["Enrollment Date"]){
    //     item["Enrollment Date"] = item?.["Enrollment Date"].replace(/-/g,"/")
    //   }

    //   if(item?.["Raising Date"]){
    //     item["Raising Date"] = item?.["Raising Date"].replace(/-/g,"/")
    //   }

    //   if(item?.["Last Rotation Date"]){
    //     item["Last Rotation Date"] = item?.["Last Rotation Date"].replace(/-/g,"/")
    //   }

    //   if(item?.["Last Alignment Date"])
    //   {
    //     item["Last Alignment Date"] = item?.["Last Alignment Date"].replace(/-/g,"/")
    //   }
        
    //   if(item?.["Removal Date"])
    //   {
    //     item["Removal Date"] = item?.["Removal Date"].replace(/-/g,"/")
    //   }


//   // }
  // });
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data, { dateNF: EXCEL_DATE_FORMAT });
  normalizeDateCells(ws);
  if (totalRow) {
    // Define the merge range
    const mergeRange = { s: { r: data.length, c: 0 }, e: { r: data.length, c: mergeCols - 1 } };
    
    // Apply merge
    if (!ws["!merges"]) ws["!merges"] = [];
  ws["!merges"].push(mergeRange);
  
    // Set the "TOTAL" cell value
    const totalCell = "A" + (data.length + 1);
    ws[totalCell] = { t: "s", v: "TOTAL" };
  
    // Apply alignment (if your library supports this via cell objects)
    ws[totalCell].s = {
      alignment: {
        horizontal: 'center',
        vertical: 'center',
      },
    };
  }
  
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  const wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'binary',
  });
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName + '.xlsx';
  link.click();
};

/**
 * Builds the "Fleet Name" cell as `fleetName(City)` when a fleet city is present.
 */
const buildFleetNameWithCity = (d) => {
  const name = d['Fleet Name'] ?? d.fleetName ?? '';
  const city = d.fleetCity ?? d['Fleet City'] ?? '';
  return name && city ? `${name}(${city})` : name;
};


/**
 * Like exportExcel, but paints the cells under `redColumn` red+bold for every
 * data row where `redRows[i]` is truthy (used to flag sold stencils, matching
 * the on-screen red). Uses xlsx-js-style because the plain `xlsx` build ignores
 * cell styling. Other reports keep using exportExcel above unchanged.
 */
export const exportExcelStyled = (
  data,
  fileName,
  { redColumn, redRows = [] } = {}
) => {
  const wb = XLSXStyle.utils.book_new();
  const ws = XLSXStyle.utils.json_to_sheet(data, { dateNF: EXCEL_DATE_FORMAT });
  normalizeDateCells(ws);

  // find the column index whose header text matches redColumn
  let colIdx = -1;
  if (redColumn && ws['!ref']) {
    const range = XLSXStyle.utils.decode_range(ws['!ref']);
    for (let c = range.s.c; c <= range.e.c; c++) {
      const headerCell = ws[XLSXStyle.utils.encode_cell({ r: 0, c })];
      if (headerCell && headerCell.v === redColumn) {
        colIdx = c;
        break;
      }
    }
  }

  if (colIdx !== -1) {
    data.forEach((_, i) => {
      if (!redRows[i]) return;
      const ref = XLSXStyle.utils.encode_cell({ r: i + 1, c: colIdx });
      const cell = ws[ref];
      if (cell) {
        cell.s = {
          ...(cell.s || {}),
          font: { ...(cell.s?.font || {}), color: { rgb: 'FFFF0000' }, bold: true },
        };
      }
    });
  }

  XLSXStyle.utils.book_append_sheet(wb, ws, 'Sheet1');
  const wbout = XLSXStyle.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'binary',
  });
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName + '.xlsx';
  link.click();
};

/**
 * Maps API / mixed-shape scrap-casing tyre rows to canonical export keys.
 */

export const normalizeScrapCasingTyreRow = (d) => {
  if (!d || typeof d !== 'object') return {};
  return {
    Zone: d.Zone ?? d.zoneName ?? '',
    Region: d.Region ?? d.regionName ?? '',
    'Fleet Name': buildFleetNameWithCity(d),
    'Hub Name': d['Hub Name'] ?? d.hubName ?? '',
    'Stencil No': d['Stencil No'] ?? d.stencilNo ?? '',
    'Tyre Company': d['Tyre Company'] ?? d.tyreCompany ?? '',
    Brand: d.Brand ?? d.brand ?? '',
    'Tube Type/Tube less': d['Product Type'] ?? d.productType ?? d.tubeType ?? '',
    'Tyre Size': d['Tyre Size'] ?? d.tyreSize ?? '',
    'Material Number': d['Material Number'] ?? d.materialNumber ?? '',
    'Application Type': d['applicationType'] ?? d.applicationType ?? '',
    Position: d.Position ?? d.position ?? '',
    'Fitment Km': d['Fitment Km'] ?? d.fitmentKm ?? '',
    ITM: d.ITM ?? d.itm ?? '',
    'RTD1': d.RTD1 ?? d.rtd1 ?? '',
    'RTD2': d.RTD2 ?? d.rtd2 ?? '',
    'RTD3': d.RTD3 ?? d.rtd3 ?? '',
    'KM Covered': d['KM Covered'] ?? d.kmCovered ?? '',
    'Standard Deviation': d['Standard Deviation'] ?? d.standardDeviation ?? '',
    'Projection KM': d['Projection KM'] ?? d.projectionKm ?? '',
    'Contract Type': d['Contract Type'] ?? d.contractType ?? '',
    'Tyre Location': d['Tyre Location'] ?? d.tyreLocation ?? '',
    'Tyre Type': d['Tyre Type'] ?? d.tyreType ?? '',
    'Casing Type': (() => {
      const val = d['Casing Type'] ?? d.casingType ?? '';
      const rowIsScrap = isScrapTyreStatus(d.status ?? d.tyreStatus ?? d['Tyre Status'] ?? d.tyre_status);
      return val !== '' ? val : (rowIsScrap ? 'SRP' : '');
    })(),
    'Scrap Reason': d['Scrap Reason'] ?? d.scrapReason ?? '',
    'IP Psi': d['IP Psi'] ?? d.ipPsi ?? '',
    'Original NSD': d['Original NSD'] ?? d.originalNsd ?? '',
    G1NSD: d.G1NSD ?? d.g1nsd ?? '',
    G2NSD: d.G2NSD ?? d.g2nsd ?? '',
    G3NSD: d.G3NSD ?? d.g3nsd ?? '',
    G4NSD: d.G4NSD ?? d.g4nsd ?? '',
    'Avg NSD': d['Avg NSD'] ?? d.avgNsd ?? '',
    'Fitment Date': d['Fitment Date'] ?? d.fitmentDate ?? '',
    'Last Insp Date':d['Last Insp Date'] ?? d.LastInspectionDate ?? d.lastInspectionDate ?? '',
    'Validation Date': d['Validation Date'] ?? d.validationDate ?? '',
    'Validated By': d['Validated By'] ?? d.validatedBy ?? '',
    validated: d.validated ?? '',
    SOLD: d.SOLD,
    'Sold Date': d['Sold Date'] ?? d.soldDate ?? '',
    'Due Days': d['Due Days'] ?? d.DueDays ?? d.dueDays ?? '',
    TAT: d.TAT ?? d.tat ?? '',
  };
};

const formatScrapCasingExportCell = (key, val, { isScrap } = {}) => {
  // Scrap tyres have no casing grade; default the empty Casing Type to "SRP".
  if (key === 'Casing Type' && isScrap && (val === null || val === undefined || val === '')) {
    return 'SRP';
  }
  if (val === null || val === undefined || val === '') return '';
  if (key === 'Fitment Date' || key === 'Last Insp Date' || key === 'Sold Date') {
    const t = new Date(val);
    return Number.isNaN(t.getTime()) ? String(val) : t.toLocaleDateString('en-GB');
  }
  if (key === 'Validation Date') {
    const t = new Date(val);
    return Number.isNaN(t.getTime())
      ? String(val)
      : t.toLocaleDateString('en-GB').replace(/\//g, '-');
  }
  if (key === 'SOLD') return val === true ? 'Yes' : val === false ? 'No' : '';
  return val;
};

/**
 * Excel download: S.No first, then fixed columns from SCRAP_CASING_TYRE_EXPORT_COLUMN_KEYS.
 */
export const exportScrapCasingTyresExcel = (rawRows, fileName = 'scrap-casing-tyres', options = {}) => {
  const { tyreStatus, useTAT = false } = options;
  const normalizedStatus = typeof tyreStatus === 'string' ? tyreStatus.toLowerCase() : '';
  // Handles "Casing", "Casing A", "Casing B"… — any casing grade has no scrap reason.
  const isCasing = normalizedStatus.startsWith('casing');
  const isScrap = normalizedStatus === 'scrap';
  // Casing tyres have no scrap reason — drop that column for casing downloads.
  // Billed & Lifted downloads use TAT instead of Due Days.
  const columnKeys = SCRAP_CASING_TYRE_EXPORT_COLUMN_KEYS
    .filter((key) => !(isCasing && key === 'Scrap Reason'))
    .filter((key) => !(useTAT && key === 'Due Days'))
    .concat(useTAT ? ['TAT'] : []);

  const safeName = String(fileName).replace(/[/\\?%*:|"<>]/g, '-');
  const sheetRows = (Array.isArray(rawRows) ? rawRows : []).map((raw, i) => {
    const n = normalizeScrapCasingTyreRow(raw);
    const row = { 'S.No': i + 1 };
    columnKeys.forEach((key) => {
      row[key] = formatScrapCasingExportCell(key, n[key], { isScrap });
    });
    return row;
  });
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(sheetRows, { dateNF: EXCEL_DATE_FORMAT });
  normalizeDateCells(ws);
  XLSX.utils.book_append_sheet(wb, ws, 'Tyres');
  const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${safeName}.xlsx`;
  link.click();
};

export default exportExcel;
